<div class="row">
  <div class="col-sm-1"></div>
  <div class="col-sm-10"></div>
  <div class="col-sm-1"></div>
</div>
<section style="overflow-x: hidden;">
  <img
    class="css-z1tvno"
    src="assets/img/walpaper.jpeg"
    alt="top-bg"
    style="
      display: block;
      position: absolute;
      width: 100%;
      height: 50vh;
      object-fit: cover;
      
      font-size: 14px;
    "
  />
</section>
<section
  style="
    padding-top: 400px;
    padding-bottom: 64px;
    position: relative;
    display: block;
    overflow-x: hidden;
  "
>
  <div
    style="
      width: 100%;
      padding-left: 15px;
      padding-right: 15px;
      margin-left: auto;
      margin-right: auto;
    "
  >
    <!-- <div
      class="css-1iki9lf"
      style="
        font-size: 32px;
        line-height: 1.41;
        color: #0a0a0a;
        font-weight: 800;
        text-align: center;
        
      "
    >
      Berbelanja kebutuhan secara digital.
    </div> -->
    <!-- <div class="css-1kzo3b9" style="overflow-x: hidden;">
      <div
        class="css-3e97yw"
        style="
          display: flex;
          flex-wrap: wrap;
          margin-left: -4px;
          margin-right: -4px;
          box-sizing: border-box;
        "
      >
        <div
          class="css-16xwx3c"
          style="
            flex: 0 0 25%;
            max-width: 25%;
            display: block;
            padding-left: 4px;
            padding-right: 4px;
            box-sizing: border-box;
          "
        >
          <div
            class="css-kuy7yq"
            style="
              font-size: 54px;
              color: #00008B;
              font-weight: 800;
              text-align: center;
              margin-top: 32px;
            "
          >
            75.000
          </div>
          <div
            class="css-188xcwv"
            style="
              font-size: 16px;
              line-height: 2;
              
              color: var(--N700, rgba(49, 53, 59, 0.68));
              text-align: center;
            "
          >
            Our Customers
          </div>
        </div>
        <div
          class="css-16xwx3c"
          style="
            flex: 0 0 25%;
            max-width: 25%;
            display: block;
            padding-left: 4px;
            padding-right: 4px;
            box-sizing: border-box;
          "
        >
          <div
            class="css-kuy7yq"
            style="
              font-size: 54px;
              color: #00008B;
              font-weight: 800;
              text-align: center;
              margin-top: 32px;
            "
          >
            3000
          </div>
          <div
            class="css-188xcwv"
            style="
              font-size: 16px;
              line-height: 2;
              
              color: var(--N700, rgba(49, 53, 59, 0.68));
              text-align: center;
            "
          >
            Our Products
          </div>
        </div>
        <div
          class="css-16xwx3c"
          style="
            flex: 0 0 25%;
            max-width: 25%;
            display: block;
            padding-left: 4px;
            padding-right: 4px;
            box-sizing: border-box;
          "
        >
          <div
            class="css-kuy7yq"
            style="
              font-size: 54px;
              color: #00008B;
              font-weight: 800;
              text-align: center;
              margin-top: 32px;
            "
          >
            16.000
          </div>
          <div
            class="css-188xcwv"
            style="
              font-size: 16px;
              line-height: 2;
              
              color: var(--N700, rgba(49, 53, 59, 0.68));
              text-align: center;
            "
          >
            Our Branches
          </div>
        </div>
        <div
          class="css-16xwx3c"
          style="
            flex: 0 0 25%;
            max-width: 25%;
            display: block;
            padding-left: 4px;
            padding-right: 4px;
            box-sizing: border-box;
          "
        >
          <div
            class="css-kuy7yq"
            style="
              font-size: 54px;
              color: #00008B;
              font-weight: 800;
              text-align: center;
              margin-top: 32px;
            "
          >
            86,5%
          </div>
          <div
            class="css-188xcwv"
            style="
              font-size: 16px;
              line-height: 2;
              
              color: var(--N700, rgba(49, 53, 59, 0.68));
              text-align: center;
            "
          >
            Seller is new businessmens
          </div>
        </div>
      </div>
    </div> -->
  </div>
</section>
<section style="display: block; overflow-x: hidden;">
  <div class="row" style="width: 100%;">
    <h1
      class="text-why-sukanda"
      style="
        font-size: 32px;
        line-height: 1.41;
        color: #0a0a0a;
        font-weight: 800;
        text-align: center;
        
      "
    >
      Why Sukanda Onelink ?
    </h1>
  </div>
  <br />
  <br />
  <br />
  <br />
  <br />
  <br />
  <div class="row" style="margin-right: auto; margin-left: auto; padding-left: 36px; padding-right: 36px;">
    <div class="col-sm-6">
      <div style="font-size: 32px;
      line-height: 1.41;
      color: #0a0a0a;
      font-weight: 800;
      ">
        <p>Invoice Digital</p>
      </div>
      <br />
      <div>
        Invoice digital dibuat untuk memudahkan pelanggan dalam menyimpan dan
        mencetak invoice sesuai kebutuhan sehingga tidak perlu repot-repot untuk
        menyimpan invoice yang diberikan sales.
      </div>
      <br />
      <div>
        "Yuk gunakan sukanda onelink dapatkan invoice dengan mudah dan praktis"
      </div>
    </div>
    <div class="col-sm-6">
      <img
        class="logo-img-x forminlinemargin"
        src="assets/img/invoice-digital.jpeg"
        style="width: 100%; height: 100%;"
      />
    </div>
  </div>
  <br />
  <br />
  <br />
  <br />
  <br />
  <br />
  <div class="row" style="margin-right: auto; margin-left: auto; padding-left: 36px; padding-right: 36px;">
    <div class="col-sm-6">
      <img
        class="logo-img-x forminlinemargin"
        src="assets/img/order-tracking-overview.jpg"
        style="width: 100%; height: auto; position: inherit;"
      />
    </div>
    <div class="col-sm-6">
      <div style="font-size: 32px;
      line-height: 1.41;
      color: #0a0a0a;
      font-weight: 800;
      ">
        <p>Track Status Order</p>
      </div>
      <br />
      <div>
        Kamu dapat mentracking status orderan dengan cepat. Status orderan kamu
        akan sistem kami update di setiap prosesnya jadi realtime.
      </div>
      <br />
      <div>
        "Track status orderan terkini bisa di sukanda onelink"
      </div>
    </div>
  </div>
  <br />
  <br />
  <br />
  <br />
  <br />
  <br />
  <div class="row" style="margin-right: auto; margin-left: auto; padding-left: 36px; padding-right: 36px;">
    <div class="col-sm-6">
      <div style="font-size: 32px;
      line-height: 1.41;
      color: #0a0a0a;
      font-weight: 800;
      ">
        <p>Sukanda Produk Catalogue</p>
      </div>
      <br />
      <div>
        Mau melihat produk-produk yang kami tawarkan ? tenang semua ada di
        sukanda produk catalogue. Sukanda produk catalogue menampilkan detail
        harga, detail produk dan ukuran dari produknya. Kamu tinggal pilih
        produk yang diinginkan dan langsung submit untuk melakukan pembayaran.
      </div>
      <br />
      <div>
        "Detail produk jelas dan banyak variasinya ada di sukanda onelink"
      </div>
    </div>
    <div class="col-sm-6">
      <img
        class="logo-img-x forminlinemargin"
        src="assets/img/product_catalogue.jpg"
        style="width: 100%; height: 100%;"
      />
    </div>
  </div>
  <br />
  <br />
  <br />
  <br />
  <br />
  <br />
  <div class="row" style="margin-right: auto; margin-left: auto; padding-left: 36px; padding-right: 36px;">
    <div class="col-sm-6">
      <img
        class="logo-img-x forminlinemargin"
        src="assets/img/history.jpeg"
        style="width: 100%; height: 100%;margin-top: -32px;"
      />
    </div>
    <div class="col-sm-6">
      <div style="font-size: 32px;
      line-height: 1.41;
      color: #0a0a0a;
      font-weight: 800;
      ">
        <p>Historical Order Data</p>
      </div>
      <br />
      <div>
        Historical order data menampilkan history-history dari semua orderan
        yang pernah dilakkuan oleh pelanggan.
      </div>
      <br />
      <div>
        "History order bisa melalui Sukanda Onelink"
      </div>
    </div>
  </div>
  <br />
  <br />
  <br />
  <br />
  <br />
  <br />
</section>
